import { TextField, Button, Typography, Container } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../service/Api';
import { useTranslation } from 'react-i18next'; 
import Switch from '@mui/material/Switch';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import '../Singup/Singup.css';

function Signup() {
  const [aceitoTermos, setAceitoTermos] = useState(false);
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [formData, setFormData] = useState({
    nome: '',
    pais: '',
    cidade: '',
    estado: '',
    email: '',
    senha: '',
    confirmacaoSenha: ''
  });

  const [senhaErro, setSenhaErro] = useState('');
  const [campoObrigatorioErro, setCampoObrigatorioErro] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const camposObrigatorios = ['nome', 'pais', 'cidade', 'email', 'senha', 'confirmacaoSenha'];
    const camposPreenchidos = camposObrigatorios.every(campo => formData[campo].trim() !== '');
    if (!camposPreenchidos) {
      setCampoObrigatorioErro('Preencha todos os campos obrigatórios');
      return;
    }

    if (formData.senha !== formData.confirmacaoSenha) {
      setSenhaErro('As senhas não correspondem');
      return;
    }
  
    if (formData.senha.length < 4 || formData.senha.length > 8) {
      setSenhaErro('A senha deve ter entre 4 e 8 caracteres');
      return;
    }
  
    try {
       const response = await Api.cadastro(formData);
       console.log(response);
       navigate('/login');
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.error;
        window.alert(errorMessage);
      } else {
        console.error('Erro ao enviar dados para a API:', error);
      }
    }
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    
    <div className="content">
      <Typography variant="h5">Sign Up</Typography>
      <Container>
        <TextField name="nome" label={t('name')} fullWidth variant="outlined" margin="normal" onChange={handleChange} required />
        <TextField name="pais" label={t('country')} fullWidth variant="outlined" margin="normal" onChange={handleChange} required />
        <TextField name="cidade" label={t('city')} fullWidth variant="outlined" margin="normal" onChange={handleChange} required />
        <TextField name="estado" label={t('state')} fullWidth variant="outlined" margin="normal" onChange={handleChange} />
        <TextField name="email" label="E-mail" fullWidth variant="outlined" margin="normal" onChange={handleChange} required />
        <TextField inputProps={{ maxLength: 8 }} name="senha" label={t('password')}  fullWidth variant="outlined" type="password" margin="normal" onChange={handleChange} required />
        <TextField inputProps={{ maxLength: 8 }} name="confirmacaoSenha" label={t('confirmpassword')} fullWidth variant="outlined" type="password" margin="normal" onChange={handleChange} required />
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <Switch checked={aceitoTermos} onChange={() => setAceitoTermos(!aceitoTermos)} />
          <Typography variant="h7"><Button onClick={handleOpen}>{t('termos-para-acesso')}</Button></Typography>
        </div>
        {senhaErro && <Typography color="error">{senhaErro}</Typography>}
        {campoObrigatorioErro && <Typography color="error">{campoObrigatorioErro}</Typography>}
        <div style={{ textAlign: 'center', margin: '20px auto' }}>
          <Button disabled={!aceitoTermos} variant="contained" color="primary" style={{ width: "150px" }} onClick={handleSubmit}>Sign Up</Button>
        </div>
        

        <div>
      
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modal-terms'>
          <Typography id="modal-modal-title" variant="h6" component="h2">
          {t('title-term')}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{color:"#000"}}>
          {t('term')}
          </Typography>
        </Box>
      </Modal>
    </div>
      </Container>
    </div>
  );
}

export default Signup;
